import { createSlice } from '@reduxjs/toolkit';
import { infoUsingPOST } from 'apis/account-controller';
import { IAccountInfoView } from 'apis/models';
import { Dispatch } from 'react';

export interface IGlobalStore {
  userInfo: undefined | IAccountInfoView;
  agreementVisible: boolean;
}
const global = createSlice({
  name: 'global',
  initialState: {
    userInfo: undefined,
  } as IGlobalStore,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.agreementVisible = !action.payload.inavadAccountInfo.agreement;
    },
    setAgreementVisible: (state, action) => {
      state.agreementVisible = action.payload;
    },
  },
});

export default global.reducer;
export const globalAction = global.actions;

export const fetchUserInfo = () => (dispatch: Dispatch<any>) => {
  infoUsingPOST()
    .then((res) => {
      console.log(res, '===!!!!');

      dispatch(globalAction.setUserInfo(res.data));
    })
    .catch((e) => {
      console.info('网络异常，刷新重试', e);
    });
};
